import { VOTEMOVEMENTS_SERVICE } from "@/services/voteMovements.service.js";

const state = { getVoteMovementsForUserOutput: {} };

const actions = {
    getVoteMovementsForUser({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getVoteMovementsForUserRequest');

        VOTEMOVEMENTS_SERVICE.getVoteMovementsForUser(id)
            .then(
                output => {
                    commit('getVoteMovementsForUserSuccess', output);
                },
                error => {
                    commit('getVoteMovementsForUserFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getVoteMovementsForUser
    getVoteMovementsForUserRequest(state) {
    },
    getVoteMovementsForUserSuccess(state, output) {
        state.getVoteMovementsForUserOutput = output;
    },
    getVoteMovementsForUserFailure(state) {
        state.getVoteMovementsForUserOutput = false;
    },
};

export const voteMovements = {
    namespaced: true,
    state,
    actions,
    mutations
};